module.exports = __webpack_public_path__ + "img/H-B-135-unload-connect.1e1916c2.png";